import { DashboardAction } from 'store/types/dashboard';
import { GET_DASHBOARD_DATA } from '../actions/types';
export interface DashboardStore {
	data: any;
}
const initialState: DashboardStore = {
	data: [],
};

export const dashboardReducer = (
	state = initialState,
	action: DashboardAction,
): DashboardStore => {
	switch (action.type) {
		case GET_DASHBOARD_DATA: {
			return {
				...state,
				data: action.payload,
			};
		}
		default: {
			return {
				...state,
			};
		}
	}
};
